import Paper from "mrf/view/Paper";
import PageTitle from "mrf/view/Title";
import React from "react";
import {Col, Grid} from "mrf/view/Grid";
import {StaticUploadButton} from "mrf/view/StaticUploadButton";

export default function Manual() {
    return (<div className='w-full'>
        <Paper>
            <PageTitle>Manual</PageTitle>
            <Grid>
                <Col size={6}>
                    <StaticUploadButton accept='.pdf' label={"Update English Manual"} endpoint={`/api/files/manual/en`}/>
                </Col>

                <Col size={6}>
                    <StaticUploadButton accept='.pdf' label={"Update Spanish Manual"} endpoint={`/api/files/manual/es`}/>
                </Col>
            </Grid>
        </Paper>
    </div>);
}